<div class="classification-config">
  @if (items.length === 0) {
    <div class="empty-state">
      <span>{{ 'MODELS.CLASSIFICATION.EMPTY' | translate }}</span>
    </div>
  }

  <div class="class-list">
    @for (item of items; track trackByIndex($index); let i = $index) {
      <div class="class-card">
        <div class="card-index">{{ i + 1 }}</div>

        <div class="card-body">
          <div class="row-top">
            <div class="field-group field-id">
              <label>{{ 'MODELS.CLASSIFICATION.FIELD.ID' | translate }}</label>
              <input
                type="text"
                [(ngModel)]="item.id"
                [name]="'class-id-' + i"
                [placeholder]="'MODELS.CLASSIFICATION.ID_PLACEHOLDER' | translate"
                [readonly]="readonly"
                (ngModelChange)="onFieldChange()"
                class="field-input id-input"
              />
            </div>
          </div>

          <div class="field-group">
            <label>{{ 'MODELS.CLASSIFICATION.FIELD.DESCRIPTION' | translate }}</label>
            <textarea
              [(ngModel)]="item.description"
              [name]="'class-desc-' + i"
              rows="2"
              [placeholder]="'MODELS.CLASSIFICATION.DESCRIPTION_PLACEHOLDER' | translate"
              [readonly]="readonly"
              (ngModelChange)="onFieldChange()"
              class="field-input"
            ></textarea>
          </div>

          <div class="field-group">
            <label>{{ 'MODELS.CLASSIFICATION.FIELD.EXAMPLES' | translate }}</label>
            <div class="chip-input" [class.readonly]="readonly">
              @for (ex of item.examples; track $index; let ei = $index) {
                <span class="chip">
                  <span class="chip-text">{{ ex }}</span>
                  @if (!readonly) {
                    <button
                      type="button"
                      class="chip-remove"
                      (click)="removeExample(i, ei, $event)"
                      [title]="'BUTTON.DELETE' | translate"
                    >
                      <fa-icon [icon]="faTimes"></fa-icon>
                    </button>
                  }
                </span>
              }
              @if (!readonly) {
                <input
                  type="text"
                  [ngModel]="exampleInputs[i]"
                  (ngModelChange)="exampleInputs[i] = $event"
                  (keydown)="onExampleKeydown($event, i)"
                  (blur)="addExample(i, exampleInputs[i])"
                  [name]="'example-input-' + i"
                  [placeholder]="item.examples.length === 0 ? ('MODELS.CLASSIFICATION.EXAMPLES_PLACEHOLDER' | translate) : ''"
                  class="chip-text-input"
                />
              }
            </div>
            @if (!readonly) {
              <span class="examples-hint">{{ 'MODELS.CLASSIFICATION.EXAMPLES_HINT' | translate }}</span>
            }
          </div>
        </div>

        @if (!readonly) {
          <button type="button" class="remove-btn" (click)="removeItem(i)" [title]="'BUTTON.DELETE' | translate">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        }
      </div>
    }
  </div>

  @if (!readonly) {
    <div class="add-options">
      <button type="button" class="add-btn" (click)="addItem()">
        <fa-icon [icon]="faPlus"></fa-icon>
        <span>{{ 'MODELS.CLASSIFICATION.ADD_CLASS' | translate }}</span>
      </button>
    </div>
  }
</div>
